import { PostUserLoginResult } from "@/request/modules/gen_api_4041";
import { createSlice } from "@reduxjs/toolkit";

interface UserReducer {
    loginResult?: PostUserLoginResult;
}

const initialState: UserReducer = {

};

const user = createSlice({
    name: "user",
    initialState,
    reducers: {
        setLoginResult: (state, { payload }) => {
            state.loginResult = payload;
        }
    },
});

export default user.reducer;